import { Store } from 'flummox';
import { canUseDOM } from 'react/lib/ExecutionEnvironment';

class CodeFormStore extends Store {

	constructor(flux) {
		super();
		const codeFormActions = flux.getActions('codeForm');
		const appStateActions = flux.getActions('appState');

		this.register(codeFormActions.setStatus, this.handleStatusChange);
		this.register(appStateActions.closeForm, this.handleCloseForm);
		this.register(codeFormActions.toggleAgree, this.handleToggleAgree);
		this.register(codeFormActions.changeValue, this.handleChange);
		this.register(codeFormActions.reset, this.handleReset);
		this.register(codeFormActions.retry, this.handleReset);
		this.registerAsync(
			codeFormActions.addPhone,
			this.startSubmit,
			this.successPhoneAdd,
			this.failSubmit
		);
		this.registerAsync(
			codeFormActions.submit,
			this.startSubmit,
			this.successSubmit,
			this.failSubmit
		);
		this.registerAsync(
			codeFormActions.submitAbuse,
			this.startSubmit,
			this.successSubmitAbuse,
			this.failSubmitAbuse
		);

		this.state = {
			usedCode: null,
			status: 'normal',
			sending: false,
			count: 0,
			code: '',
			phone: '',
			abuse: '',
			abused: false,
			agree: false,
			ratingLabel: ''
		};
	}

	handleStatusChange(status) {
		this.setState({status});
	}

	handleToggleAgree() {
		this.setState({
			agree: !this.state.agree
		});
	}

	handleReset() {
		this.setState({
			usedCode: null,
			status: 'normal',
			sending: false,
			count: 0,
			code: '',
			abuse: '',
			abused: false,
			agree: false,
			ratingLabel: ''
		});
	}

	handleCloseForm() {
		setTimeout(this.handleReset.bind(this), 300);
	}

	handleChange({name, value}) {
		this.setState({
			[name]: value
		});
	}

	startSubmit() {
		this.setState({
			sending: true
		});
	}

	successSubmit(response) {
		if(response.status === 'success') {
			this.setState({
				status: 'success',
				usedCode: response.usedCode,
				sending: false,
				count: response.count || 0,
				ratingLabel: response.ratingLabel
			});
		} else {
			this.setState({
				usedCode: response.usedCode,
				status: 'fail',
				sending: false
			});
		}
	}

	failSubmit() {

	}

	successSubmitAbuse() {
		this.setState({
			sending: false,
			abused: true
		});
	}

	successPhoneAdd(response) {
		this.setState({
			usedCode: null,
			sending: false,
			count: response.count || 0,
			ratingLabel: response.ratingLabel
		});
	}

	failSubmitAbuse() {

	}

}

CodeFormStore.serialize = (state) => {
	return JSON.stringify(state);
};

CodeFormStore.deserialize = (string) => {
	return JSON.parse(string);
};

export default CodeFormStore;



// WEBPACK FOOTER //
// ./src/stores/CodeFormStore.js